/**
 * Generate random string
 */
// eslint-disable-next-line newline-per-chained-call
const generateRandomString = (): string => Math.random().toString(36).substring(7);

export default generateRandomString;
